import React, { useEffect, useMemo, useRef } from 'react';
import { Column } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { FormRef, Label, SimpleItem } from "devextreme-react/form";
import IInstitutionFinanciere from "../../models/IInstitutionFinanciere";
import { FormListBase, FormListBaseGrid, FormListBaseTab, FormListBaseToolbar } from '../base';
import useCustomDataSource, { Mode } from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';

interface IGestionInstitutionsFinancieresProps {
  isModeSelection?: boolean,
}

export default function GestionInstitutionsFinancieres({ isModeSelection }: IGestionInstitutionsFinancieresProps) {
  const institutionFormDataSource = useCustomDataSource<IInstitutionFinanciere, IInstitutionFinanciere>({
    path: "institutionFinanciere",
    primaryKey: "idInstitutionFinanciere"
  });
  const { selectedDataRow: selectedInstitutionFinanciere, mode, onFieldDataChanged, setMode, setMainForm, isFieldModifier, setIsFieldModifier } = institutionFormDataSource;
  const formRef = useRef<FormRef>(null);

  const descriptionOptions = useMemo(() => {
    return { maxLength: 200, width: 300 };
  }, []);
  const adresseOptions = useMemo(() => {
    return { maxLength: 127, width: 300 };
  }, []);
  const compteOptions = useMemo(() => {
    return { maxLength: 12, width: 100 };
  }, []);
  const transitOptions = useMemo(() => {
    return { maxLength: 10, width: 100 };
  }, []);
  const actifOptions = useMemo(() => {
    return { text: "Actif" };
  }, []);

  useEffect(() => {
    setMainForm(formRef.current?.instance());
  })

  useEffect(() => {
    if (mode !== Mode.Lecture) formRef.current?.instance().getEditor("description")?.focus();
  }, [mode])

  console.log(selectedInstitutionFinanciere)
  return (
    <FormListBase data={institutionFormDataSource}>
      <FormListBaseGrid
        dataSource={institutionFormDataSource.dataSource}
        onFocusedRowChanged={() => {
          if (mode === Mode.Modifier) {
            setMode(Mode.Lecture)
          }
        }}
      >
        <Column key={"grid-col-description"} dataField={"description"} caption="Description" allowHiding={false} />
        <Column key={"grid-col-compte"} dataField={"compte"} caption="Compte" allowHiding={false} />
        <Column key={"grid-col-transit"} dataField={"transit"} caption="Transit" allowHiding={false} />
        <Column key={"grid-col-id-folio"} dataField={"idFolio"} caption="Folio" allowHiding={false} />
      </FormListBaseGrid>
      <FormListBaseToolbar headerText={`${selectedInstitutionFinanciere?.description || ''} `} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} effacerOptions={{ disabled: !isFieldModifier }} />
      {!isModeSelection || isModeSelection && mode !== Mode.Lecture ? <FormListBaseTab>
        <TabItem title="Informations">
          <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedInstitutionFinanciere || {} as IInstitutionFinanciere} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
            <SimpleItem key={"frm-description"} dataField={"description"} editorOptions={
              descriptionOptions} />
            <SimpleItem key={"frm-adresse"} dataField={"adresse"}
              editorOptions={adresseOptions} />
            <SimpleItem key={"frm-compte"} dataField={"compte"}
              editorOptions={compteOptions} />
            <SimpleItem key={"frm-transit"} dataField={"transit"}
              editorOptions={transitOptions} />
            <SimpleItem key={"frm-chiffre-verificateur"} dataField={"chiffreVerificateur"}
              editorOptions={{ width: 100 }}
            >
              <Label text={"Chiffre vérificateur"} />
            </SimpleItem>
            <SimpleItem key={"frm-id-folio"} dataField={"idFolio"}
              editorOptions={{ width: 200 }}
            >
              <Label text={"Folio"} />
            </SimpleItem>
            <SimpleItem key={"frm-actif"} dataField={"actif"} editorType={"dxCheckBox"}
              editorOptions={actifOptions}
            >
              <Label visible={false} />
            </SimpleItem>
          </Form>
        </TabItem>
        <TabItem title="Système"><FormSysteme formData={selectedInstitutionFinanciere || {} as IInstitutionFinanciere} /></TabItem>
      </FormListBaseTab> : null}
    </FormListBase>
  );
}
